<div>
<mat-tab-group mat-align-tabs="center" [selectedIndex]="tabIndex" (selectedTabChange)="navigate($event)">
    <mat-tab *ngFor="let tab of navLinks" [label]="tab.label"></mat-tab>
</mat-tab-group>
</div>